import { render, staticRenderFns } from "./UploadNotSuccessful.vue?vue&type=template&id=c28acdc0&"
import script from "./UploadNotSuccessful.vue?vue&type=script&lang=js&"
export * from "./UploadNotSuccessful.vue?vue&type=script&lang=js&"
import style0 from "./UploadNotSuccessful.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports